import { addDays, isAfter, isBefore, differenceInHours } from "date-fns";
const districts = [
  "Tawang",
  "West Kameng",
  "East Kameng",
  "Papum Pare",
  "Kurung Kumey",
  "Kra Daadi",
  "Lower Subansiri",
  "Upper Subansiri",
  "West Siang",
  "East Siang",
  "Siang",
  "Upper Siang",
  "Lower Siang",
  "Lower Dibang Valley",
  "Dibang Valley",
  "Anjaw",
  "Lohit",
  "Namsai",
  "Changlang",
  "Tirap",
  "Longding",
  "Itanagar"
];
const districtCoordinates = {
  "Tawang": { x: 10, y: 80 },
  "West Kameng": { x: 15, y: 65 },
  "East Kameng": { x: 25, y: 60 },
  "Papum Pare": { x: 35, y: 50 },
  "Kurung Kumey": { x: 35, y: 75 },
  "Kra Daadi": { x: 40, y: 70 },
  "Lower Subansiri": { x: 45, y: 60 },
  "Upper Subansiri": { x: 50, y: 75 },
  "West Siang": { x: 60, y: 65 },
  "East Siang": { x: 65, y: 55 },
  "Siang": { x: 60, y: 75 },
  "Upper Siang": { x: 70, y: 85 },
  "Lower Siang": { x: 60, y: 50 },
  "Lower Dibang Valley": { x: 80, y: 65 },
  "Dibang Valley": { x: 85, y: 85 },
  "Anjaw": { x: 95, y: 70 },
  "Lohit": { x: 85, y: 55 },
  "Namsai": { x: 80, y: 45 },
  "Changlang": { x: 85, y: 35 },
  "Tirap": { x: 80, y: 25 },
  "Longding": { x: 75, y: 15 },
  "Itanagar": { x: 36, y: 48 }
};
const purposes = ["Tourism", "Business", "Employment", "Education", "Transit"];
const ovdTypes = ["Aadhaar", "Voter ID", "Passport", "Driving License"];
const names = [
  "Rahul Sharma",
  "Priya Das",
  "Amit Gogoi",
  "Sunita Pegu",
  "Vikram Singh",
  "Anjali Borah",
  "Sanjay Meena",
  "Deepika Roy",
  "Arjun Thapa",
  "Kavita Devi",
  "Rajesh Kumar",
  "Sneha Patil",
  "Manoj Tiwari",
  "Pooja Hegde",
  "Rohan Gupta"
];
const APPLICANT_COUNT = 480;
/** Total mock revenue: 48.6 Cr (INR) distributed across applicants */
const TOTAL_REVENUE_RUPEES = 486000000;

const generateMockData = () => {
  const weights = Array.from({ length: APPLICANT_COUNT }, () => 0.35 + Math.random());
  const wSum = weights.reduce((a, b) => a + b, 0);
  const applicants = [];
  const now = /* @__PURE__ */ new Date();
  let allocated = 0;
  for (let i = 1; i <= APPLICANT_COUNT; i++) {
    const entryOffset = Math.floor(Math.random() * 100) - 10;
    const duration = Math.floor(Math.random() * 14) + 3;
    const entryDate = addDays(now, entryOffset);
    const exitDate = addDays(entryDate, duration);
    let status = "Active";
    const hoursToExit = differenceInHours(exitDate, now);
    const hoursToEntry = differenceInHours(entryDate, now);
    if (isAfter(entryDate, now)) {
      if (hoursToEntry <= 48) {
        status = "Upcoming";
      } else {
        status = "Pending";
      }
    } else if (isBefore(exitDate, now)) {
      status = "Defaulted";
    } else if (hoursToExit <= 48) {
      status = "Expiring";
    }
    const ovd = ovdTypes[Math.floor(Math.random() * ovdTypes.length)];
    let idNum = "";
    if (ovd === "Aadhaar") idNum = `${Math.floor(1e3 + Math.random() * 9e3)} ${Math.floor(1e3 + Math.random() * 9e3)} ${Math.floor(1e3 + Math.random() * 9e3)}`;
    else if (ovd === "Voter ID") idNum = `ABC${Math.floor(1e6 + Math.random() * 9e6)}`;
    else if (ovd === "Passport") idNum = `Z${Math.floor(1e6 + Math.random() * 9e6)}`;
    else idNum = `DL-${Math.floor(1e9 + Math.random() * 9e9)}`;
    const feePaid =
      i < APPLICANT_COUNT
        ? Math.floor(TOTAL_REVENUE_RUPEES * weights[i - 1] / wSum)
        : TOTAL_REVENUE_RUPEES - allocated;
    if (i < APPLICANT_COUNT) allocated += feePaid;
    applicants.push({
      id: `APP-${1e3 + i}`,
      name: names[i % names.length],
      permitId: `ILP-${2024e3 + i}`,
      district: districts[Math.floor(Math.random() * districts.length)],
      purpose: purposes[Math.floor(Math.random() * purposes.length)],
      entryDate,
      exitDate,
      status,
      phone: `+91 ${Math.floor(1e9 + Math.random() * 9e9)}`,
      ovdType: ovd,
      idNumber: idNum,
      feePaid
    });
  }
  return applicants;
};
export {
  districtCoordinates,
  districts,
  generateMockData,
  ovdTypes,
  purposes
};
